<template>
  <v-app>
    <!-- header -->
    <div
      class="d-flex d-block-on-movile"
      style="position:absolute; flex-direction:row; margin-top:15px; width:100%"
    >
      <img
        class="resizable-img"
        style="object-fit:contain; margin-left:20px; margin-right:20px; max-width:200px; cursor:pointer!important; z-index:2;"
        src="/logo_estado_plurinacional.png"
        @click="dialogAyuda = false"
      >
      <v-spacer />
      <img
        class="resizable-img"
        style="object-fit:contain; margin-left:20px; margin-right:20px; max-width:180px;"
        src="/nuevo_logo_aj.png"
      >
    </div>
    <!-- body -->
    <v-content
      class="responsive-ajustador-max-width"
      style="z-index:2;"
    >
      <v-container
        fluid
        fill-height
      >
        <v-layout
          row
          wrap
          align-center
          justify-center
        >
          <!-- Login -->
          <v-flex
            xs10
            sm6
            md6
            lg5
            xl5
          >
            <v-layout
              align-center
              justify-center
            >
              <div
                v-if="showMessage === ''"
                class="text-xs-center"
              >
                <v-progress-circular
                  :size="100"
                  :width="3"
                  color="purple"
                  indeterminate
                >
                  Verificando
                </v-progress-circular>
              </div>
              <div>
                <v-alert
                  v-if="showMessage"
                  :value="true"
                  color="success lighten-1"
                  icon="verified"
                >
                  Verificación exitosa.
                </v-alert>

                <v-alert
                  v-else-if="showMessage === false"
                  :value="true"
                  color="error lighten-1"
                  icon="new_releases"
                >
                  Ocurrió un error al intentar verificar el correo electrónico.
                </v-alert>
                <!-- <div class="text-xs-center">
                  <v-btn
                    v-if="showMessage && !$store.state.sessionIciado"
                    color="secondary darken-1"
                    @click="$router.push('/')"
                  >
                    <v-icon>
                      home
                    </v-icon> Inicio
                  </v-btn>
                </div> -->
              </div>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <!-- footer -->
    <div
      class="d-flex d-block-on-movile align-baseline"
      style="position:absolute; flex-direction:row; bottom:0; width:100%;"
    >
      <div style="margin-left:20px;margin-bottom: 8px;">
        <em class="caption">&copy; Autoridad de Fiscalización del Juego.</em><br>
        <em class="caption">Plataforma AJ en Línea v.3 - Bolivia, {{ new Date().getFullYear() }}</em>
      </div>
      <v-spacer />
      <img
        class="resizable-img"
        style="object-fit: contain;margin-bottom:15px; max-width:80px;"
        src="/logo_iso.png"
      >
    </div>

    <v-menu
      :open-on-hover="true"
      offset-y
      offset-x
      right
      top
      :nudge-right="-20"
      :nudge-top="-10"
    >
      <template v-slot:activator="{ on }">
        <v-avatar
          size="60"
          color="green"
          style="position:fixed; bottom:50px; left:20px; z-index:2; cursor:pointer;"
          v-on="on"
          @click.stop="whatsappWeb()"
        >
          <IconWhatsapp
            color="white"
            :size="42"
          />
        </v-avatar>
      </template>
      <v-card color="terciary darken-1">
        <v-card-text class="pa-2 white--text caption">
          ¿Necesitas ayuda? Escríbenos ahora...
        </v-card-text>
      </v-card>
    </v-menu>
  </v-app>
</template>

<script>
import types from "@/store/types/Usuario";
import { mapActions } from "vuex";
import IconWhatsapp from "@/components/Icons/IconWhatsapp"

export default {
  components: {
    IconWhatsapp,
  },
  data() {
    return {
      messageWhatsapp: '',
      urlContactoWhatsappSoporte: `https://wa.me/${process.env.VUE_APP_NUMBER_WHATSAPP_SOPORTE}?text=`,
      showMessage: '',
    };
  },
  computed:{},
  mounted() {
    this.verificarCorreo(this.$route.query.sec)
  },
  methods: {
    whatsappWeb(){
      this.messageWhatsapp = `Hola, escribo para realizar la siguiente consulta:`
      window.open(this.urlContactoWhatsappSoporte + encodeURIComponent(this.messageWhatsapp), '_blank')
    },
    async verificarCorreo(token){

      let _datos = {
        token: token,
      }

      await fetch(`${process.env.VUE_APP_API_AJAYU}pajel/usuario_empresa/verificacion_correo`, {
        method: "POST",
        body: JSON.stringify(_datos),
        headers: {"Content-type": "application/json; charset=UTF-8"}
      })
      .then(response => response.json())
      .then(data => {

        if(this.$store.state.sessionIciado && data.status !== 'BAD_REQUEST'){
          const nuevosDatosSesion = {...this.$store.state.datosSession}
          nuevosDatosSesion.datosEmpresa.correoCorporativo = data.email;
          this.$store.commit("actualizarDatosSession", nuevosDatosSesion);
        }
        this.$router.push("/ActualizaCorreo");

        this.$cadenas.Mensaje(
          "notificacion",
          "Mensaje",
          data.message,
          data.status === 'BAD_REQUEST' ? "error" : "success"
        );
        this.showMessage = data.status === 'BAD_REQUEST' ? false : true
      })
      .catch(error => {
        this.$cadenas.Mensaje(
          "notificacion",
          "Mensaje",
          "Ocurrió un error al intentar verificar el correo electrónico.",
          "error"
        );
        this.showMessage = false
      });

    },
    ...mapActions({
      Login: types.actions.Login,
      ResetearClave: types.actions.ResetearClave,
      ReactivarCuenta: types.actions.ReactivarCuenta,
      RepresentanteLegal:types.actions.RepresentanteLegal
    }),
  },
};
</script>

<style>
</style>
